import {
    setSelectedImage,
    setBackdropOpen,
    setMessage,
} from "../reducers/common";
import { AppThunk } from "../redux/store";
import { MessageObject } from "../typeDefs/common";

export const handleOpen =
    (url: string): AppThunk<void> =>
    (dispatch) => {
        dispatch(setSelectedImage(url));
        dispatch(setBackdropOpen(true));
    };

export const handleClose = (): AppThunk<void> => (dispatch) => {
    dispatch(setSelectedImage(""));
    dispatch(setBackdropOpen(false));
};

export const setSuccessMessage =
    (message: string): AppThunk<void> =>
    (dispatch) => {
        const messageObject: MessageObject = {
            text: message,
            status: "success",
            open: true,
        };
        dispatch(setMessage(messageObject));
    };

export const setErrorMessage =
    (message: string, redirectUrl?: string): AppThunk<void> =>
    (dispatch) => {
        const messageObject: MessageObject = {
            text: message,
            status: "error",
            open: true,
            redirectUrl,
        };
        dispatch(setMessage(messageObject));
    };
